(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slideshow-controls"] && !Shopify.designMode) return;
  try {
    // Thumbnail navigation arrows functionality
  document.addEventListener('DOMContentLoaded', () => {
    const initThumbnailArrows = () => {
      document.querySelectorAll('.slideshow-controls__thumbnails-wrapper').forEach(wrapper => {
        const container = wrapper.querySelector('.slideshow-controls__thumbnails-container');
        const prevBtn = wrapper.querySelector('.slideshow-controls__thumbnail-arrow--prev');
        const nextBtn = wrapper.querySelector('.slideshow-controls__thumbnail-arrow--next');

        if (!container || !prevBtn || !nextBtn) return;

        const updateArrowVisibility = () => {
          const scrollLeft = container.scrollLeft;
          const maxScroll = container.scrollWidth - container.clientWidth;

          container.setAttribute('data-can-scroll-left', scrollLeft > 5 ? 'true' : 'false');
          container.setAttribute('data-can-scroll-right', scrollLeft < maxScroll - 5 ? 'true' : 'false');
        };

        const scrollAmount = 150;

        prevBtn.addEventListener('click', () => {
          container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', () => {
          container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        container.addEventListener('scroll', updateArrowVisibility);
        window.addEventListener('resize', updateArrowVisibility);

        // Initial check
        setTimeout(updateArrowVisibility, 100);
      });
    };

    initThumbnailArrows();

    // Re-initialize on Shopify section load/unload for theme editor
    document.addEventListener('shopify:section:load', initThumbnailArrows);
  });
  } catch(e) { console.error(e); }
})();

})();
